import { render, staticRenderFns } from "./ForgotEmail.vue?vue&type=template&id=1825102d&scoped=true"
import script from "./ForgotEmail.vue?vue&type=script&lang=js"
export * from "./ForgotEmail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./ForgotEmail.vue?vue&type=style&index=2&id=1825102d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825102d",
  null
  
)

export default component.exports